import { Interp, css } from '../../lib/render.jsx';

/**
 * Het ballonnetje naast een gereedschap: wat het doet en welke toets erbij hoort.
 *
 * Je roept het zelf op door een knop aan te wijzen. Het vangt geen muis (zie
 * pointerEvents in tipStyle) en heeft dus ook geen eigen sluitknop: weg met de
 * muis is weg met de ballon.
 */
export default function Tip({ v }) {
  if (!v.showTip) return null;
  return (
    <div style={css(v.tipStyle)}>
      <span style={{ "position": "absolute", "left": "-11px", "top": "50%", "marginTop": "-9px", "width": "18px", "height": "18px", "background": "var(--paars)", "borderLeft": "3px solid var(--ink)", "borderBottom": "3px solid var(--ink)", "borderRadius": "0 0 0 6px", "transform": "rotate(45deg)" }} />
      <div style={{ "display": "flex", "alignItems": "center", "gap": "8px" }}>
        <span style={{ "fontSize": "15px", "fontWeight": "700" }}>
          <Interp v={v.tipTitle} />
        </span>
        {v.showTipKey ? (
          <span style={{ "marginLeft": "auto", "display": "inline-flex", "alignItems": "center", "justifyContent": "center", "minWidth": "22px", "height": "22px", "padding": "0 6px", "borderRadius": "8px", "background": "#fff", "border": "2px solid var(--ink)", "boxShadow": "0 2px 0 var(--ink)", "fontSize": "12px", "fontWeight": "700", "color": "var(--ink)" }}>
            <Interp v={v.tipKey} />
          </span>
        ) : null}
      </div>
      <div style={{ "fontSize": "14px", "fontWeight": "600", "lineHeight": "1.4", "textWrap": "pretty" }}>
        <Interp v={v.tipText} />
      </div>
    </div>
  );
}
